import React, { useMemo } from 'react';

import { CourseList } from './courseList/CourseList';
import { Divider, SectionHeader } from 'app/components/common';

import { useCourseListQuery } from '../../../hooks/gql';

import './styles.less';

export const HomePage = ( props ) => {
    const { data, loading: isCourseListLoading } = useCourseListQuery();
    const courseList = useMemo( () => data ? data.courseList.courses : [], [ data ] );

    return (
        <div>
            <SectionHeader>My Learning</SectionHeader>
            <CourseList loading={ isCourseListLoading } courseList={ [ ...courseList ] } token={ props.route.params.token } />
            <Divider />
        </div>
    );
};
